//BUYERS Listing
export const FETCH_PCUSER_LISTING_FAILURE = 'FETCH_PCUSER_LISTING_FAILURE';
export const FETCH_PCUSER_LISTING_SUCCESS = 'FETCH_PCUSER_LISTING_SUCCESS';

export const RESET = 'RESET';
